 
import React, { useState, useEffect } from "react";
import { Button, Form, Input, Upload, Space, Divider, Flex } from "antd";
import {
  DeleteOutlined,
  UploadOutlined,
  PlusOutlined,
} from "@ant-design/icons";

const InclusionsEditor = ({ slide, updateSlide, removeSlide, triggerSave }) => {
  const [points, setPoints] = useState(slide.points || []);
  const [newPoint, setNewPoint] = useState("");
  const [formData, setFormData] = useState(slide);

 
  useEffect(() => {
    setFormData(slide);
    setPoints(slide.points || []);
  }, [slide]);

 
  useEffect(() => {
    updateSlide(slide.id, { ...formData, points });
  }, [triggerSave]);

  
  const addPoint = (text) => {
    const raw = text ?? newPoint;
    if (!raw) return;
    const newItems = raw
      .split(/\r?\n/)
      .map((s) => s.trim())
      .filter((s) => s.length > 0);
    if (newItems.length === 0) return;
    setPoints((prev) => [...prev, ...newItems]);
    setNewPoint("");
  };

  const updatePoint = (idx, value) => {
    const next = [...points];
    next[idx] = value;
    setPoints(next);
  };

  const removePoint = (idx) => {
    setPoints(points.filter((_, i) => i !== idx));
  };

  const handleNewKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      addPoint();
    }
  };

  const handlePaste = (e) => {
    const paste = (e.clipboardData || window.clipboardData).getData("text");
    if (paste && paste.includes("\n")) {
      e.preventDefault();
      addPoint(paste);
    }
  };

 
  const handleBgUpload = (info) => {
    const file = info.file.originFileObj || info.file;
    if (file && file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        setFormData((prev) => ({ ...prev, bg: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="border rounded-lg p-3 bg-white shadow-sm">
      <Divider />
      <h1 className="font-semibold mb-4 text-lg">Edit Inclusion Slide</h1>
      <Form layout="vertical">
        <Form.Item label="Heading">
          <Input
            value={formData.heading || "INCLUSIONS"}
            onChange={(e) =>
              setFormData({ ...formData, heading: e.target.value })
            }
          />
        </Form.Item>

        <Form.Item label="Inclusions - Points">
          {points.map((p, idx) => (
            <div key={idx} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
              <Input
                value={p}
                onChange={(e) => updatePoint(idx, e.target.value)}
                maxLength={200}
                showCount
              />
              <Button danger onClick={() => removePoint(idx)}>
                <DeleteOutlined />
              </Button>
            </div>
          ))}

          <div style={{ display: "flex", gap: 8 }}>
            <Input
              placeholder="Type a new point and press Enter or click Add"
              value={newPoint}
              onChange={(e) => setNewPoint(e.target.value)}
              onKeyDown={handleNewKeyDown}
              onPaste={handlePaste}
            />
            <Button
              icon={<PlusOutlined />}
              onClick={() => addPoint()}
              className="!w-auto !px-4 !hover:bg-[#031B76]/90"
            />
          </div>
        </Form.Item>

        <Form.Item label="Background & Remove">
          <Flex vertical gap={15}>
            <Upload
              accept="image/*"
              beforeUpload={() => false}
              showUploadList={false}
              onChange={handleBgUpload}
            >
              <Button type="primary">
                <UploadOutlined /> Upload Background
              </Button>
            </Upload>
            {formData.bg && (
              <img
                src={formData.bg}
                alt="Background Preview"
                className="block mt-2 w-full h-32 max-w-xs max-h-xs object-cover rounded-lg border"
              />
            )}
            <Button
              className="mt-2"
              danger
              type="primary"
              onClick={() => removeSlide(slide.id)}
            >
              <DeleteOutlined /> Remove Slide
            </Button>
          </Flex>
        </Form.Item>
      </Form>
    </div>
  );
};

export default InclusionsEditor;
